module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTYuMjMgMTkyLjMxIj48ZGVmcz48c3R5bGU+LmF7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+aG9tZTwvdGl0bGU+PHBhdGggY2xhc3M9ImEiIGQ9Ik0zMi4wNSw5NnY5Ni4yNkgxNjQuMThWOTZMOTguMTIsMzBabTEwMSwxOXYyNi4wNmgtMjJ2MjJIODUuMDl2LTIyaC0yMlYxMTVoMjJ2LTIyaDI2LjA2djIyWiIvPjxwb2x5Z29uIGNsYXNzPSJhIiBwb2ludHM9Ijk4LjEyIDAgMCA5OC4xMiAxMi4zNiAxMTAuNDggOTguMTIgMjQuNzIgMTgzLjg3IDExMC40OCAxOTYuMjMgOTguMTIgOTguMTIgMCIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home.svg
// module id = 144
// module chunks = 114276838955818 162898551421021